import React, { Component } from "react";
import { connect } from "react-redux";
import AOS from "aos";
import { assessmentActions } from "../../../_actions";
import HeaderTransprent from "./Component/HeaderTransprent";
import Footer from "./Component/Footer";
import Ready from "../../../components/Ready";
import { Helmet } from "react-helmet";
import OrgType from "./Component/OrgType";
import { FiArrowUpRight } from "react-icons/fi";
import Marquee from "react-fast-marquee";
import TestHeader from "../../../components/TestHeader";
// import Accordion from "../../../components/UI/Accordion";
import AccordionHome from "../../../components/UI/AccordionHome";
import JsonData from "../../JsonData/jsonData.json"
import { LuDot } from "react-icons/lu";
// import { GoOrganization } from "react-icons/go";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination, Mousewheel, Keyboard, Autoplay } from 'swiper/modules';
// import Testimonials from "./Component/Testimonial";

class HomeTwo extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: "",
      otp_code: "",
      notFoundText: "",
      showLogin: true,
      failureMSG: "",
      failureOTPMSG: "",
      quantity: 1,
      formData: {
        'type': 'Individual'
      },
      showOrgTypeModal: false,
      hoveredElement: 1,
      hoveredElementtwo: 1,
      hoveredElementthree: 1,
      // selectedImage: JsonData.individualInsights[0].image,
      // selectedImagetwo: JsonData.organizationalInsights[0].image,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.dispatch(assessmentActions.userAssessmentUserProfile('getAssessmentCartCount'));
    this.props.dispatch(assessmentActions.getAssessmentPackagesShortList());
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out",
      delay: 100,
    });
  }
  handleHover = (element) => {
    this.setState({ hoveredElement: element });
  };
  handleHovertwo = (element) => {
    this.setState({ hoveredElementtwo: element });
  };

  handleHoverthree = (element) => {
    this.setState({ hoveredElementthree: element });
  };

  logout = () => {
    this.props.dispatch(assessmentActions.AssessmentUserLogout(this.props));
  };

  handleSignInPage = () => {
    localStorage.removeItem("route");
    localStorage.setItem("route", this.props.history.location.pathname);
    this.props.history.push(`/assessment/sign-in`);
  };

  gotoPage = (field) => {
    let { assessment } = this.props;
    let { userAssessmentUserProfileData } = assessment;

    if (field === "my-cart") {
      if (
        !(userAssessmentUserProfileData && userAssessmentUserProfileData.email)
      ) {
        this.props.history.push(`/assessment/` + "sign-in");
      } else {
        this.props.history.push(`/assessment/` + field);
      }
    } else {
      this.props.history.push(`/assessment/` + field);
    }
  };

  // gotoPage = (field) => {
  //   const { assessment } = this.props;
  //   const { userAssessmentUserProfileData } = assessment;

  //   if (field === "my-cart") {
  //     if (!(userAssessmentUserProfileData && userAssessmentUserProfileData.email)) {
  //       this.props.history.push(`/assessment/sign-in`);
  //     } else {
  //       this.props.history.push(`/assessment/${field}`);
  //     }
  //   } else {
  //     this.props.history.push(`/assessment/${field}`);
  //   }
  // };


  gotoMyAccount = (field) => {
    let userDetails = this.props.assessment.userAssessmentUserProfileData;
    if (userDetails && userDetails.email) {
      this.props.history.push(`/assessment/` + field);
    } else {
      localStorage.removeItem("route");
      localStorage.setItem("route", `/assessment/` + field);
      this.props.history.push(`/assessment/sign-in`);
    }
  };

  handleDownload = () => {
    let code = "TalentPlusStrengths21";
    const link = document.createElement("a");
    link.href = "/" + code.toString() + ".pdf";
    link.download = code.toString() + ".pdf";
    link.click();
  };

  handleRedirect = () => {
    this.props.history.push("/assessment/how-talentplus-strength-works");
    window.scrollTo(0, 0);
  };

  closeOrgTypeModal = () => {
    this.setState({ showOrgTypeModal: false })
  }


  handleOptionInput = (value) => {
    let { formData } = this.state;
    formData["type"] = value;
    this.setState({ formData });
  };

  handleOptionSubmit = () => {
    let { formData } = this.state;
    if (formData["type"] === "Individual") {
      this.props.history.push(`/assessment/` + "surveylogin");
    } else if (formData["type"] === "Organization") {
      window.location.href = 'https://plusinsight.happyplus.in/surveylink/#/assessment/signin';
    }
  };


  handleTakeAssessmentRedirect = () => {
    this.setState({ showOrgTypeModal: false }, () => {
      this.handleOptionSubmit();
    })
  }

  handleScrollToSection = () => {
    const section = document.getElementById("section2");
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  handleIndividualInsights = (index) => {
    this.setState((prevState) => ({
      individualOpenIndex: prevState.individualOpenIndex === index ? null : index,
      // selectedImage:
      //   prevState.individualOpenIndex === index
      //     ? prevState.selectedImage
      //     : JsonData.individualInsights[index].image
    }));
  };

  handleOrganizationalInsights = (index) => {
    this.setState((prevState) => ({
      organizationalOpenIndex: prevState.organizationalOpenIndex === index ? null : index,
      // selectedImagetwo:
      //   prevState.organizationalOpenIndex === index
      //     ? prevState.selectedImagetwo
      //     : JsonData.organizationalInsights[index].image
    }));
  };

  render() {
    // const { hoveredElement } = this.state;
    // const { hoveredElementtwo } = this.state;
    const { hoveredElementthree } = this.state;

    let { assessment } = this.props;
    let {
      userAssessmentUserProfileData,
      getAssessmentCartCountData,
      getAssessmentPackagesShortListData,
    } = assessment;
    let { showOrgTypeModal, formData } = this.state;
    // console.log("quantity-->", quantity);


    return (
      <div className="overflow-hidden ">

        <Helmet>
          <meta charSet="utf-8" />
          <title>TalentPlusStrengths – Discover Your Unique Strengths & Unlock Potential</title>
          <meta name="description" content="India’s leading strengths assessment platform. Identify, understand, and apply your talents to build stronger teams and better performance." />
          <meta name="keywords" content="strengths assessment,talent development platform,personal strengths test,employee engagement assessment,strengths-based leadership,team strengths analysis,talent insights platform,personal strengths, career growth,leadership development, strengths-based coaching" />
          <meta name="author" content="TalentPlusStrengths" />
          <meta name="viewport" content="width=device-width, initial-scale=1.0" />
          <meta property="og:title" content="TalentPlusStrengths – Discover Your Unique Strengths & Unlock Potential" />
          <meta property="og:description" content="India’s leading strengths assessment platform. Identify, understand, and apply your talents to build stronger teams and better performance." />
          <meta property="og:image" content="https://talentplusstrengths.com/img/TalentPlusStrengths_logo.svg" />
          <meta property="og:url" content="https://talentplusstrengths.com/#/assessment/home" />
          <meta property="og:type" content="website" />
          <link rel="canonical" href="https://talentplusstrengths.com/#/assessment/home" />
        </Helmet>

        <section
          className="bg-[#2196F3]/10 w-full h-auto  bg-cover bg-no-repeat bg-right "
          style={{
            backgroundImage: `url('/img/assessment/bg-gradient.webp')`,
          }}
        >

          <HeaderTransprent
            handleSignInPage={this.handleSignInPage}
            userDetails={userAssessmentUserProfileData}
            logout={this.logout}
            gotoPage={this.gotoPage}
            cartCount={getAssessmentCartCountData ? getAssessmentCartCountData : 0}
            props2={this.props}
            prodList={getAssessmentPackagesShortListData}
            gotoMyAccount={this.gotoMyAccount}
          />
          <TestHeader
            handleTakeAssessmentRedirect={this.handleTakeAssessmentRedirect}
          />
          {/* Hero Section */}
          <div className="w-full h-full">
            <div className="flex flex-col w-full h-full gap-8 py-12 md:flex-row xl:px-0 px-4 mx-auto">
              <div className="flex flex-col justify-center w-full h-full pt-12 pb-8 2xl:pl-56 xl:pl-[4rem] mx-auto my-auto space-y-8 text-center md:pb-10 md:pt-0 md:text-left ">
                {/* <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest ">Employer Solutions</p> */}
                <h1 data-aos="fade-right" className="xl:text-5xl text-4xl leading-[3rem] xl:leading-[3.5rem] font-bold text-[#212121]  capitalize">Re-Discover Yourself by Identifying Your Strengths</h1>
                <div data-aos="fade-right" className="font-medium lg:text-lg text-base space-y-2">
                  <p className="text-[#212121]">Are you still wondering “how to identify your natural strengths” or struggling to understand what makes you unique? </p>
                  {/* <p className="text-[#212121]">With the TalentPlusStrengths assessment, you can uncover your true talents, gain clarity, and receive a personalized strengths report that helps you grow in your career, relationships, and leadership journey. </p> */}
                  <p className="text-[#212121]">Start today and unlock the power of your strengths.</p>
                </div>
                <div className="flex flex-row items-center justify-center gap-4 md:justify-start md:items-center">
                  <button data-aos="fade-right" onClick={() => this.gotoPage("employer")} className="bg-[#212121] hover:bg-[#1976D2] hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-150  text-white py-2.5 px-6 rounded uppercase cursor-pointer flex w-fit justify-center">  Employers</button>
                  <button data-aos="fade-right" onClick={() => this.gotoPage("individual")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span> Individual</span>{/* <TbChevronRight className="text-[1.5rem]" /> */}</button>
                  <button data-aos="fade-right" onClick={() => this.gotoPage("teen-talent")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>
                    teen</span>{/* <TbChevronRight className="text-[1.5rem]" /> */}</button>
                </div>
              </div>

              <div className="flex items-end justify-center w-full lg:justify-end pt-6 pr-0 lg:pr-4">
                <img data-aos="fade-left" src="/img/assessment/talentplusstrengths-image.webp" alt="re-discover-yourself-using" className="z-0 w-full h-full object-contain" />
              </div>
            </div>
          </div>
        </section>

        {/* Marquee section */}
        <section className="bg-[#DBEEFD]">
          <section className="w-full py-10 mx-auto space-y-6 text-center ">
            <h1 data-aos="slide-up" className="xl:text-2xl text-lg  font-semibold text-[#212121] capitalize flex flex-wrap justify-center px-4">
              <p> Trusted by leading global enterprises and humans everywhere <span onClick={this.handleScrollToSection} className="text-[#2196F3] underline pl-3 cursor-pointer uppercase">See All</span></p>
            </h1>
            <Marquee className="flex flex-row w-full gap-10">
              <div className="flex flex-row justify-between w-full gap-10 ">
                {JsonData.companyLogo.map((client, index) => (
                  <img key={index} className="border border-[#FFFFFF] bg-white h-24" src={client.src} alt={client.alt} loading="lazy" />
                ))}
              </div>
            </Marquee>
          </section>
        </section>

        <section className="pb-16 pt-20">
          <div className="px-4 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <div className="mx-auto grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
              <div className="w-full md:pr-8 pr-0">
                <Swiper cssMode={true} autoplay={true} mousewheel={true} keyboard={true} loop={true} pagination={{ clickable: true, }}
                  modules={[Autoplay, Navigation, Pagination, Mousewheel, Keyboard]} className="mySwiper">
                  {JsonData.empowerWorkforceImg.map((item, index) => (
                    <SwiperSlide>
                      <div>
                        <img data-aos="fade-left" src={item.image} alt={item.title} className="z-0 shadow-lg" />
                        <div className="mt-10 bg-white"></div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
              <div className="w-full">
                <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest pb-4">Employer Solutions</p>
                <h2 className="2xl:text-5xl md:text-4xl text-3xl capitalize font-bold textblack text-start">Empower Your Workforce with TalentPlusStrengths</h2>
                <p className="text-lg text-[#212121] pt-4 text-left">Boost employee productivity, enhance team collaboration, and transform workplace performance with our strengths-based assessment and development solutions.</p>
                <div className="py-6">
                  {JsonData.empowerWorkforce.map((item, index) => (
                    <AccordionHome
                      key={index}
                      title={item.title}
                      description={item.description}
                      para={item.para}
                      list={item.list}
                      icon={item.icon}
                      // img={this.state.selectedImagetwo}
                      isOpen={this.state.organizationalOpenIndex === index}
                      onClick={() => this.handleOrganizationalInsights(index)}
                      {...item}
                    />
                  ))}
                </div>
                <div className="flex flex-row justify-start gap-4 py-4 space-y-2">
                  <button data-aos="fade-right" onClick={() => this.gotoPage("employer")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>  Learn More</span><FiArrowUpRight className="text-[1.5rem]" /></button>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-16">
          <div className="px-4 mx-auto 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <div className="mx-auto grid lg:grid-cols-2 grid-cols-1 gap-8 items-center">
              <div className="w-full order-2 lg:order-1">
                <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest pb-4">Individual Solutions</p>
                <h2 className="2xl:text-5xl md:text-4xl text-3xl capitalize font-bold textblack text-start">Discover Your Natural Talents with TalentPlusStrengths for Personal and Professional Growth</h2>
                <p className="text-lg text-[#212121] pt-4 text-left">Career Excellence, Work-Life Harmony, Enhanced Self-Awareness, and Stronger Family Bonds.</p>
                <div className="py-6">
                  {JsonData.unlockPotential.map((item, index) => (
                    <AccordionHome
                      key={index}
                      title={item.title}
                      description={item.description}
                      para={item.para}
                      list={item.list}
                      icon={item.icon}
                      // img={this.state.selectedImage}
                      isOpen={this.state.individualOpenIndex === index}
                      onClick={() => this.handleIndividualInsights(index)}
                      {...item}
                    />
                  ))}
                </div>
              </div>
              <div className="w-full md:pl-8 pl-0 order-1 lg:order-2">
                <Swiper cssMode={true} autoplay={true} mousewheel={true} keyboard={true} loop={true} pagination={{ clickable: true, }}
                  modules={[Autoplay, Navigation, Pagination, Mousewheel, Keyboard]} className="mySwiper">
                  {JsonData.unlockPotentialImg.map((item, index) => (
                    <SwiperSlide key={index}>
                      <div>
                        <img data-aos="fade-left" src={item.image} alt={item.title} className="z-0 shadow-lg" />
                        <div className="mt-10 bg-white"></div>
                      </div>
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>
            </div>
            <div className="flex flex-row justify-start gap-4 py-4 space-y-2">
              <button data-aos="fade-right" onClick={() => this.gotoPage("individual")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>  Learn More</span><FiArrowUpRight className="text-[1.5rem]" /></button>
            </div>
          </div>
        </section>


        {/* <div className="py-10 space-y-10 md:py-20 md:space-y-16">
                <section className="w-full space-y-6">
            <section className="flex flex-col items-start w-full gap-10 py-10 lg:flex-row 2xl:gap-20 lg:gap-10 md:gap-20 img-changer">

                           <div className="lg:w-[60%] w-full flex flex-col justify-end lg:pl-10 px-4">
                <img className="w-full mx-auto hometwo-hover-img-1 " src="/img/assessment/Empower-Workforce.webp" alt="Empower-Workforce" />
              </div>
              <div data-aos="fade-right" className="lg:w-[40%] w-full text-left grid grid-cols-1 gap-0 2xl:mr-[8%] xl:mr-[4%] xl:px-0 px-4 mx-auto ">
                <div className="mb-6 space-y-3 text-center lg:text-left">
                  <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest">Employer Solutions</p>
                  <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">Empower Your Workforce with TalentPlusStrengths</h1>
                  <p className="text-lg text-[#3D405B]">Boost employee productivity, enhance team collaboration, and transform workplace performance with our strengths-based assessment and development solutions.</p>
                </div>
                {JsonData.empowerWorkforce.map((items, index) => (
                  <>
                    <div class="bg-white rounded-md cursor-pointer transition-all duration-150 py-4 px-6 hover:bg-gradient-to-b from-[#2196f3]/10 to-transparent">
                      <div class="flex items-start space-x-4">
                       
                        <span className="text-4xl">{items.icon}</span>
                        <div class="text-left space-y-2">
                          <h3 class="text-lg font-semibold textblack">{items.title}</h3>
                          <p class="text-base text-[#212121]/70">{items.description}</p>
                        </div>
                      </div>
                    </div>                   
                  </>
                ))}
                <div className="flex flex-row justify-start gap-4 px-6 py-4 space-y-2">
                  <button data-aos="fade-right" onClick={() => this.gotoPage("employer")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>  Learn More</span><FiArrowUpRight className="text-[1.5rem]" /></button>
                </div>
              </div >
            </section>
          </section>

          <section className="w-full space-y-6 ">
            <section className="flex flex-col-reverse items-start w-full gap-10 py-10 lg:flex-row 2xl:gap-20 lg:gap-10 md:gap-20 img-changer ">
              <div data-aos="fade-right" className="lg:w-[40%] w-full text-left  grid grid-cols-1 gap-0 2xl:ml-[8%] xl:ml-[4%] xl:px-0 px-4 mx-auto ">
                <div className="mb-6 space-y-3 text-center lg:text-left">
                  <p data-aos="fade-right" className="text-base text-[#2196F3] font-medium uppercase tracking-widest">Individual Solutions</p>
                  <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem]  capitalize font-bold text-[#212121]">Discover Your Natural Talents with TalentPlusStrengths for Personal and Professional Growth</h1>
                  <p className="text-xl text-[#3D405B] ">Career Excellence, Work-Life Harmony, Enhanced Self-Awareness, and Stronger Family Bonds.
                  </p>
                </div>
                {JsonData.unlockPotential.map((items, index) => (
                  <>
                    <div class="bg-white rounded-md cursor-pointer transition-all duration-150 py-4 px-6 hover:bg-gradient-to-b from-[#2196f3]/10 to-transparent">
                      <div class="flex items-start space-x-4">
                        <span className="text-4xl">{items.icon}</span>
                        <div class="text-left space-y-2">
                          <h3 class="text-lg font-semibold textblack">{items.title}</h3>
                          <p class="text-base text-[#212121]/70">{items.description}</p>
                        </div>
                      </div>
                    </div>
                  </>
                ))}

                <div className="flex flex-row justify-start gap-4 px-6 py-4 space-y-2">
                  <button data-aos="fade-right" onClick={() => this.gotoPage("individual")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>  Learn More</span><FiArrowUpRight className="text-[1.5rem]" /></button>
                </div>

              </div>
              <div className="lg:w-[60%] w-full flex flex-col justify-end lg:pr-10 px-4">
                <img
                  className="w-full mx-auto hometwo-hover-img-1"
                  src="/img/assessment/unlock-your-potential-with-talentplus.webp"
                  alt="unlock-your-potential-with-TalentPlusStrengths"
                />
              </div>
            </section>
          </section>
        </div> */}

        {/* section 3*/}
        <section className="w-full py-16 space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')`, }}>
          <div className="px-4 mx-auto mb-6 space-y-4 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-[#212121]">How TalentPlusStrengths Works</h1>
            <p className="lg:text-lg text-sm text-[#212121]">The TalentPlusStrengths assessment is designed to help you unlock your full potential by identifying and developing your natural talents. With personalized insights and practical feedback, you’ll gain tools to achieve career excellence, build enhanced self-awareness, and strengthen family and workplace relationships.</p>
          </div>
          <div className="flex flex-col-reverse items-start w-full gap-10 py-10 lg:flex-row lg:gap-10 md:gap-20">
            {/* text */}
            <div data-aos="fade-right" className="lg:w-[40%] w-full text-left grid grid-cols-1 gap-0 2xl:ml-[8%] xl:ml-[4%] xl:px-0 px-4 mx-auto ">

              <div
                onMouseEnter={() => this.handleHoverthree(1)}
                className={`rounded-md cursor-pointer transition-all duration-150 py-6 px-6 hover:border-[#2196F3] space-y-2 ${hoveredElementthree === 1 ? '  bg-gradient-to-b from-[#2196f3]/10 to-transparent' : ''
                  }`}
              >
                <h2 className="text-xl font-bold text-[#212121]">1. Discover Your natural Strengths: A Comprehensive 40-Minute Assessment</h2>
                <p className="text-base text-[#212121]/70 ">Wondering how to identify your natural strengths? Our 40-minute strengths assessment guides you through 140 statement sets covering 28 themes within 4 domains: THINKING,  RELATING, ACTING and LEADING. Each statement helps uncover your patterns of behavior, emotion, and thinking—giving you clarity on what you do best.</p>
              </div>

              <div
                onMouseEnter={() => this.handleHoverthree(2)}
                className={`rounded-md cursor-pointer transition-all duration-150 py-6 px-6    hover:border-[#2196F3] space-y-2 ${hoveredElementthree === 2 ? '  bg-gradient-to-b from-[#2196f3]/10 to-transparent  ' : ''
                  }`}
              >
                <h2 className="text-xl font-bold text-[#212121]">2. Master Your Potential: Strengths Assessment for Individuals, Leaders, and Teams</h2>
                <p className="text-base text-[#212121]/70 ">Looking for the best strengths assessment tools for individuals, teams or a strengths assessment tool for leadership? TalentPlusStrengths provides personalized reports and insights that highlight your unique talents while fostering stronger individual performance and team collaboration.</p>
              </div>

              <div
                onMouseEnter={() => this.handleHoverthree(3)}
                className={`rounded-md cursor-pointer transition-all duration-150 py-6 px-6 hover:border-[#2196F3] space-y-2 ${hoveredElementthree === 3 ? '  bg-gradient-to-b from-[#2196f3]/10 to-transparent  ' : ''
                  }`}
              >
                <h2 className="text-xl font-bold text-[#212121]">3. Personalized Strengths Reports with Practical Feedback</h2>
                <p className="text-base text-[#212121]/70 ">Every participant receives a personalized strengths report packed with actionable features, including detailed insights into your top 5 strengths. Whether you’re focusing on relationship building strengths in the workplace or learning how to apply your talents in new ways, the report helps you translate insights into growth.</p>
              </div>

              <div className="flex flex-row justify-start gap-4 px-6 py-4 space-y-2">
                <button data-aos="fade-right" onClick={() => this.gotoPage("how-talentplus-strength-works")} className="flex space-x-2 items-center  border border-black  hover:shadow-[0px_5px_1px_0px_rgba(0,0,0,10)] shadow-black  transition-all duration-200  text-black py-2.5 md:px-6 px-4 rounded uppercase cursor-pointer w-fit justify-center"> <span>  Learn More</span><FiArrowUpRight className="text-[1.5rem]" /></button>
              </div>

            </div>

            {/* img */}
            <div className="lg:w-[60%] w-full flex flex-col justify-end lg:pr-10 px-4">
              {hoveredElementthree === 1 ? <img
                className="w-full mx-auto "
                src="/img/assessment/assessment_survey.webp"
                alt="unlock-your-potential-with-TalentPlusStrengths"
              /> : null}
              {hoveredElementthree === 2 ? <img
                className="w-full mx-auto "
                src="/img/assessment/summary_report.webp"

                alt="unlock-your-potential-with-TalentPlusStrengths"
              /> : null}
              {hoveredElementthree === 3 ? <img
                className="w-full mx-auto "
                src="/img/assessment/detail_report.webp"
                alt="unlock-your-potential-with-TalentPlusStrengths"
              /> : null}
            </div>
          </div>
        </section>

        <section className="w-full py-16 space-y-6 bg-white">
          <div className="px-4 mx-auto mb-6 space-y-4 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <div className="text-center mb-12">
              <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-[#212121]">
                Achieve Growth with Personalized Insights
              </h2>
              <p className="mt-4 lg:text-lg text-sm text-[#212121]">
                By leveraging personalized insights and feedback, you can achieve
                growth in every area of life. Here’s how it helps:
              </p>
            </div>

            <div className="grid md:grid-cols-2 grid-cols-1 gap-6">
              {JsonData.TalentPlusStrengthsWorks.map((item, idx) => (
                <div key={idx} className="p-6 bg-white rounded-2xl border hover:shadow-lg">
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-4xl">{item.icon}</span>
                    <h3 className="text-xl font-bold text-[#212121]">
                      {item.title}
                    </h3>
                  </div>
                  {item.points.map((point, i) => (
                    <div key={i} className="flex items-start space-x-2 text-base text-[#212121]">
                      <LuDot size={30} className="shrink-0 " />
                      <p>{point}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </section>


        <section className="w-full py-16 space-y-6 bg-cover" style={{ backgroundImage: `url('/img/assessment/bg-gradient.webp')`, }}>
          <div className="px-4 mx-auto space-y-2 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0">
            {/* Heading */}
            <p className="text-pink-600 font-semibold tracking-widest uppercase">Achievements</p>
            <h2 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-[#212121]">Our Growing Impact</h2>
            <p className="lg:text-lg text-sm text-[#212121]">Together, we’re creating measurable impact.</p>

            {/* Stats Grid */}
            <div className="pt-6 grid grid-cols-1 md:grid-cols-3 gap-10">
              {JsonData.stats.map((item, i) => (
                <div key={i} className="bg-white rounded-2xl shadow-sm p-8 flex flex-col items-center border hover:shadow-md hover:border-sky-500">
                  <span className="bg-gradient-to-r from-violet-800 to-sky-500 bg-clip-text text-transparent text-4xl md:text-6xl font-medium">{item.value}</span>
                  <span className="textblack mt-2">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </section>


        {/*All Company logo*/}
        <section id="section2" className="w-full py-20 space-y-6 bg-cover bg-white">
          <div className="px-4 mx-auto mb-6 space-y-4 text-center 2xl:w-9/12 xl:w-11/12 xl:px-0">
            <h1 className="2xl:text-5xl md:text-4xl text-3xl xl:leading-[3rem] 2xl:leading-[4rem] capitalize font-bold text-[#212121]">Some of our esteemed clients</h1>
            <p className="text-xl text-[#3D405B]">Trusted by leading global enterprises and humans everywhere</p>
            <section className="flex flex-col-reverse items-start w-full gap-10 pt-10 lg:flex-row lg:gap-10 md:gap-20">
              <div data-aos="fade-right" className="w-full text-left grid xl:grid-cols-4 lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-8">
                {JsonData.companyLogo.map((client, index) => (
                  <img key={index} className="border border-[#E8E8E8] w-full h-28 object-contain" src={client.src} alt={client.alt} loading="lazy" />
                ))}
              </div>
            </section>
          </div>
        </section>

        {/* <Testimonials /> */}

        {
          showOrgTypeModal ? (
            <OrgType
              closeModal={this.closeOrgTypeModal}
              formData={formData}
              handleOptionInput={this.handleOptionInput}
              handleOptionSubmit={this.handleOptionSubmit}
            />
          ) : null
        }


        <Ready />

        <Footer
          props2={this.props}
          prodList={getAssessmentPackagesShortListData}
          gotoMyAccount={this.gotoMyAccount}
        />
      </div>
    );
  }
}
HomeTwo.defaultProps = {
  center: { lat: 26.953021, lng: 75.739797 },
  zoom: 15,
};
function mapStateToProps(state) {
  //console.log("state  ", state);
  const { loggingIn } = state.authentication;
  const { questions, user, assessment } = state;
  return {
    loggingIn,
    questions,
    user,
    assessment,
  };
}

export default connect(mapStateToProps)(HomeTwo);
